import {connect} from 'react-redux';
import {compose, lifecycle} from 'recompose';
import SignOutPage from '../pages/SignOutPage';
import withSignout from '../hoc/withSignout';

export default compose(
  withSignout,
  connect(state => ({
    reason: state.auth.signOutReason,
    authenticated: state.auth.authenticated
  })),
  lifecycle({
    componentDidMount() {
      this.props.signOut();
    }
  })
)(SignOutPage);
